import {Component, OnInit} from "@angular/core";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {HttpClient} from "@angular/common/http";
import {TaskStatus, TasksV1Service, Department, EmployeesV1Service, AuthV1Service} from "../../../apis/backend";
import {firstValueFrom, Observable} from "rxjs";

@Component({
    selector: 'credentials-dialog',
    templateUrl: './credentials-dialog.component.html',
})
export class CredentialsDialogComponent {
    
    public EmployeeID: number;
    public Username: string;
    public Password: string = "";
    public PasswordConfirm: string = "";
    
    constructor(public ActiveModal: NgbActiveModal,
                public AuthService: AuthV1Service,
                public EmployeeService: EmployeesV1Service) {
    }

    public Save() {
        if (!this.Password || this.Password != this.PasswordConfirm) {
            return;
        }
        if (this.EmployeeID) {
            firstValueFrom(this.EmployeeService
                .setCredentialsForEmployee(
                    this.EmployeeID,
                    {
                        Username: this.Username,
                        Password: this.Password,
                    }))
                .then(() => this.ActiveModal.close());
        }
        {
            firstValueFrom(this.AuthService
                .createUser(
                    {
                        Username: this.Username,
                        Password: this.Password,
                    }))
                .then(() => this.ActiveModal.close());
        }
    }

    public Cancel() {
        this.ActiveModal.dismiss();
    }
}